// 公共数据源
const genderOps = [
  {
    code: 'M',
    name: '男'
  },
  {
    code: 'F',
    name: '女'
  }
];
const idTypeOps = [
  { code: '1', name: '居民身份证' },
  { code: '2', name: '护照' },
  { code: '8', name: '出生证' },
  { code: '9', name: '户口本' },
  { code: '7', name: '港澳台居民居住证' }
];
export default {
  // 需要新增被保人功能的产品code列表
  productCodeList: ['DB_BJ_019', 'ZLZRY', 'DBZGD', 'LBZGD', 'DB_BJ_024', 'ZLZRY2023', 'DBZRY2023', 'DBZGD2023', 'LBZGD2023', 'DB_BJ_034', 'ZLLXS2022', 'ZLLXS2022A'],
  // 被保人基础修改字段
  insuredFields: [
    { label: '被保人姓名', key: 'name' },
    { label: '证件类型', key: 'idType', dataSource: idTypeOps },
    { label: '证件号码', key: 'idNumber' },
    { label: '出生日期', key: 'birthDate' },
    { label: '性别', key: 'gender', dataSource: genderOps },
    { label: '手机号', key: 'mobile' }
  ],
  // 是否数据源
  yesNoOps: [
    {
      code: 'Y',
      name: '是'
    },
    {
      code: 'N',
      name: '否'
    }
  ],
  // 有无数据源
  yesNoOps1: [
    {
      code: '1',
      name: '无'
    },
    {
      code: '2',
      name: '涵盖'
    }
  ],
  // 性别数据源
  genderOps,
  // 证件类型数据源
  idTypeOps,
  // 护照数据源
  passportOps: [{ code: '2', name: '护照' }],
  // 护照、出生证数据源
  globalOps: [
    { code: '2', name: '护照' },
    { code: '8', name: '出生证' }
  ],
  // 被保人证件类型数据源（中国国籍）
  insuredIdType1Ops: [
    { code: '1', name: '居民身份证' },
    { code: '8', name: '出生证' },
    { code: '9', name: '户口本' }
  ],
  // 被保人证件类型数据源（非中国国籍）
  insuredIdType2Ops: [
    { code: '2', name: '护照' },
    { code: '7', name: '港澳台居民居住证' },
    { code: '8', name: '出生证' }
  ],
  // 与投保人关系数据源
  relationshipOps: [
    // { code: '1', name: '本人' },
    { code: '2', name: '配偶' },
    { code: '3', name: '子女' }
  ],
  // 目前在中国数据源
  workUnitOps: [
    { code: '1', name: '工作' },
    { code: '2', name: '生活' },
    { code: '3', name: '学习' }
  ],
  // 证件有效期数据源
  invalidateOps: [
    { code: '0', name: '非长期有效' },
    { code: '1', name: '长期有效' }
  ],
  // 社保数据源
  socialsecurityOps: [
    { code: 'Y', name: '有' },
    { code: 'N', name: '无' }
  ],
  // 国籍数据源
  countryOps: [
    { code: 'CHN', name: '中国大陆' },
    { code: 'ABW', name: '阿鲁巴' },
    { code: 'AFG', name: '阿富汗' },
    { code: 'AGO', name: '安哥拉' },
    { code: 'AIA', name: '安圭拉' },
    { code: 'ALB', name: '阿尔巴尼亚' },
    { code: 'AND', name: '安道尔' },
    { code: 'ANT', name: '荷属安的列斯' },
    { code: 'ARE', name: '阿联酋' },
    { code: 'ARG', name: '阿根廷' },
    { code: 'ARM', name: '亚美尼亚' },
    { code: 'ASM', name: '美属萨摩亚' },
    { code: 'ATA', name: '南极洲' },
    { code: 'ATF', name: '法属南部领土' },
    { code: 'ATG', name: '安提瓜和巴布达' },
    { code: 'AUS', name: '澳大利亚' },
    { code: 'AUT', name: '奥地利' },
    { code: 'AZE', name: '阿塞拜疆' },
    { code: 'BDI', name: '布隆迪' },
    { code: 'BEL', name: '比利时' },
    { code: 'BEN', name: '贝宁' },
    { code: 'BFA', name: '布基纳法索' },
    { code: 'BGD', name: '孟加拉国' },
    { code: 'BGR', name: '保加利亚' },
    { code: 'BHR', name: '巴林' },
    { code: 'BHS', name: '巴哈马' },
    { code: 'BIH', name: '波斯尼亚和黑塞哥维那' },
    { code: 'BLR', name: '白俄罗斯' },
    { code: 'BLZ', name: '伯利兹' },
    { code: 'BMU', name: '百慕大' },
    { code: 'BOL', name: '玻利维亚' },
    { code: 'BRA', name: '巴西' },
    { code: 'BRB', name: '巴巴多斯' },
    { code: 'BRN', name: '文莱' },
    { code: 'BTN', name: '不丹' },
    { code: 'BVT', name: '布维岛' },
    { code: 'BWA', name: '博茨瓦纳' },
    { code: 'CAF', name: '中非' },
    { code: 'CAN', name: '加拿大' },
    { code: 'CCK', name: '科科斯（基林）群岛' },
    { code: 'CHE', name: '瑞士' },
    { code: 'CHL', name: '智利' },
    { code: 'CIV', name: '科特迪瓦' },
    { code: 'CMR', name: '喀麦隆' },
    { code: 'COG', name: '刚果' },
    { code: 'COK', name: '库克群岛' },
    { code: 'COL', name: '哥伦比亚' },
    { code: 'COM', name: '科摩罗' },
    { code: 'CPV', name: '佛得角' },
    { code: 'CRI', name: '哥斯达黎加' },
    { code: 'CTN', name: '中国台湾' },
    { code: 'CUB', name: '古巴' },
    { code: 'CXR', name: '圣诞岛' },
    { code: 'CYM', name: '开曼群岛' },
    { code: 'CYP', name: '塞浦路斯' },
    { code: 'CZE', name: '捷克' },
    { code: 'DEU', name: '德国' },
    { code: 'DJI', name: '吉布提' },
    { code: 'DMA', name: '多米尼克' },
    { code: 'DNK', name: '丹麦' },
    { code: 'DOM', name: '多米尼加共和国' },
    { code: 'DZA', name: '阿尔及利亚' },
    { code: 'ECU', name: '厄瓜多尔' },
    { code: 'EGY', name: '埃及' },
    { code: 'ERI', name: '厄立特里亚' },
    { code: 'ESH', name: '西撒哈拉' },
    { code: 'ESP', name: '西班牙' },
    { code: 'EST', name: '爱沙尼亚' },
    { code: 'ETH', name: '埃塞俄比亚' },
    { code: 'FIN', name: '芬兰' },
    { code: 'FJI', name: '斐济' },
    { code: 'FLK', name: '马尔维纳斯群岛（福克兰群岛）' },
    { code: 'FRA', name: '法国' },
    { code: 'FRO', name: '法罗群岛' },
    { code: 'FSM', name: '密克罗尼西亚' },
    { code: 'GAB', name: '加蓬' },
    { code: 'GBR', name: '英国' },
    { code: 'GEO', name: '格鲁吉亚' },
    { code: 'GHA', name: '加纳' },
    { code: 'GIB', name: '直布罗陀' },
    { code: 'GIN', name: '几内亚' },
    { code: 'GLP', name: '瓜德罗普' },
    { code: 'GMB', name: '冈比亚' },
    { code: 'GNB', name: '几内亚比绍' },
    { code: 'GNQ', name: '赤道几内亚' },
    { code: 'GRC', name: '希腊' },
    { code: 'GRD', name: '格林纳达' },
    { code: 'GRL', name: '格陵兰' },
    { code: 'GTM', name: '危地马拉' },
    { code: 'GUF', name: '法属圭亚那' },
    { code: 'GUM', name: '关岛' },
    { code: 'GUY', name: '圭亚那' },
    { code: 'HKG', name: '中国香港' },
    { code: 'HMD', name: '赫德岛和麦克唐纳岛' },
    { code: 'HND', name: '洪都拉斯' },
    { code: 'HRV', name: '克罗地亚' },
    { code: 'HTI', name: '海地' },
    { code: 'HUN', name: '匈牙利' },
    { code: 'IDN', name: '印度尼西亚' },
    { code: 'IND', name: '印度' },
    { code: 'IOT', name: '英属印度洋领土' },
    { code: 'IRL', name: '爱尔兰' },
    { code: 'IRN', name: '伊朗' },
    { code: 'IRQ', name: '伊拉克' },
    { code: 'ISL', name: '冰岛' },
    { code: 'ISR', name: '以色列' },
    { code: 'ITA', name: '意大利' },
    { code: 'JAM', name: '牙买加' },
    { code: 'JOR', name: '约旦' },
    { code: 'JPN', name: '日本' },
    { code: 'KAZ', name: '哈萨克斯坦' },
    { code: 'KEN', name: '肯尼亚' },
    { code: 'KGZ', name: '吉尔吉斯斯坦' },
    { code: 'KHM', name: '柬埔寨' },
    { code: 'KIR', name: '基里巴斯' },
    { code: 'KNA', name: '圣基茨和尼维斯' },
    { code: 'KOR', name: '韩国' },
    { code: 'KWT', name: '科威特' },
    { code: 'LAO', name: '老挝' },
    { code: 'LBN', name: '黎巴嫩' },
    { code: 'LBR', name: '利比里亚' },
    { code: 'LBY', name: '利比亚' },
    { code: 'LCA', name: '圣卢西亚' },
    { code: 'LIE', name: '列支敦士登' },
    { code: 'LKA', name: '斯里兰卡' },
    { code: 'LSO', name: '莱索托' },
    { code: 'LTU', name: '立陶宛' },
    { code: 'LUX', name: '卢森堡' },
    { code: 'LVA', name: '拉脱维亚' },
    { code: 'MAC', name: '中国澳门' },
    { code: 'MAR', name: '摩洛哥' },
    { code: 'MCO', name: '摩纳哥' },
    { code: 'MDA', name: '摩尔多瓦' },
    { code: 'MDG', name: '马达加斯加' },
    { code: 'MDV', name: '马尔代夫' },
    { code: 'MEX', name: '墨西哥' },
    { code: 'MHL', name: '马绍尔群岛' },
    { code: 'MKD', name: '马其顿' },
    { code: 'MLI', name: '马里' },
    { code: 'MLT', name: '马耳他' },
    { code: 'MMR', name: '缅甸' },
    { code: 'MNG', name: '蒙古' },
    { code: 'MNP', name: '北马里亚纳' },
    { code: 'MOZ', name: '莫桑比克' },
    { code: 'MRT', name: '毛里塔尼亚' },
    { code: 'MSR', name: '蒙特塞拉特' },
    { code: 'MTQ', name: '马提尼克' },
    { code: 'MUS', name: '毛里求斯' },
    { code: 'MWI', name: '马拉维' },
    { code: 'MYS', name: '马来西亚' },
    { code: 'MYT', name: '马约特' },
    { code: 'NAM', name: '纳米比亚' },
    { code: 'NCL', name: '新喀里多尼亚' },
    { code: 'NER', name: '尼日尔' },
    { code: 'NFK', name: '诺福克岛' },
    { code: 'NGA', name: '尼日利亚' },
    { code: 'NIC', name: '尼加拉瓜' },
    { code: 'NIU', name: '纽埃' },
    { code: 'NLD', name: '荷兰' },
    { code: 'NOR', name: '挪威' },
    { code: 'NPL', name: '尼泊尔' },
    { code: 'NRU', name: '瑙鲁' },
    { code: 'NZL', name: '新西兰' },
    { code: 'OMN', name: '阿曼' },
    { code: 'PAK', name: '巴基斯坦' },
    { code: 'PAN', name: '巴拿马' },
    { code: 'PCN', name: '皮特凯恩群岛' },
    { code: 'PER', name: '秘鲁' },
    { code: 'PHL', name: '菲律宾' },
    { code: 'PLW', name: '贝劳' },
    { code: 'PNG', name: '巴布亚新几内亚' },
    { code: 'POL', name: '波兰' },
    { code: 'PRI', name: '波多黎各' },
    { code: 'PRK', name: '朝鲜' },
    { code: 'PRT', name: '葡萄牙' },
    { code: 'PRY', name: '巴拉圭' },
    { code: 'PST', name: '巴勒斯坦' },
    { code: 'PYF', name: '法属波利尼西亚' },
    { code: 'QAT', name: '卡塔尔' },
    { code: 'REU', name: '留尼汪' },
    { code: 'ROM', name: '罗马尼亚' },
    { code: 'RUS', name: '俄罗斯' },
    { code: 'RWA', name: '卢旺达' },
    { code: 'SAU', name: '沙特阿拉伯' },
    { code: 'SDN', name: '苏丹' },
    { code: 'SEN', name: '塞内加尔' },
    { code: 'SGP', name: '新加坡' },
    { code: 'SGS', name: '南乔治亚岛和南桑德韦奇岛' },
    { code: 'SHN', name: '圣赫勒拿' },
    { code: 'SJM', name: '斯瓦尔巴群岛' },
    { code: 'SLB', name: '所罗门群岛' },
    { code: 'SLE', name: '塞拉利昂' },
    { code: 'SLV', name: '萨尔瓦多' },
    { code: 'SMR', name: '圣马力诺' },
    { code: 'SOM', name: '索马里' },
    { code: 'SPM', name: '圣皮埃尔和密克隆' },
    { code: 'STP', name: '圣多美和普林西比' },
    { code: 'SUR', name: '苏里南' },
    { code: 'SVK', name: '斯洛伐克' },
    { code: 'SVN', name: '斯洛文尼亚' },
    { code: 'SWE', name: '瑞典' },
    { code: 'SWZ', name: '斯威士兰' },
    { code: 'SYC', name: '塞舌尔' },
    { code: 'SYR', name: '叙利亚' },
    { code: 'TCA', name: '特克斯和凯科斯群岛' },
    { code: 'TCD', name: '乍得' },
    { code: 'TGO', name: '多哥' },
    { code: 'THA', name: '泰国' },
    { code: 'TJK', name: '塔吉克斯坦' },
    { code: 'TKL', name: '托克劳' },
    { code: 'TKM', name: '土库曼斯坦' },
    { code: 'TMP', name: '东帝汶' },
    { code: 'TON', name: '汤加' },
    { code: 'TTO', name: '特立尼达和多巴哥' },
    { code: 'TUN', name: '突尼斯' },
    { code: 'TUR', name: '土耳其' },
    { code: 'TUV', name: '图瓦卢' },
    { code: 'TZA', name: '坦桑尼亚' },
    { code: 'UGA', name: '乌干达' },
    { code: 'UKR', name: '乌克兰' },
    { code: 'URY', name: '乌拉圭' },
    { code: 'USA', name: '美国' },
    { code: 'UZB', name: '乌兹别克斯坦' },
    { code: 'VAT', name: '梵蒂冈' },
    { code: 'VCT', name: '圣文森特和格林纳丁斯' },
    { code: 'VEN', name: '委内瑞拉' },
    { code: 'VGB', name: '英属维尔京群岛' },
    { code: 'VIR', name: '美属维尔京群岛' },
    { code: 'VNM', name: '越南' },
    { code: 'VUT', name: '瓦努阿图' },
    { code: 'WLF', name: '瓦利斯和富图纳群岛' },
    { code: 'WSM', name: '西萨摩亚' },
    { code: 'YEM', name: '也门' },
    { code: 'YUG', name: '南斯拉夫' },
    { code: 'ZAF', name: '南非' },
    { code: 'ZAR', name: '扎伊尔' },
    { code: 'ZMB', name: '赞比亚' },
    { code: 'ZWE', name: '津巴布韦' }
  ]
};
